import { render, staticRenderFns } from "./PageMediaHeader.vue?vue&type=template&id=ae8c588c&"
import script from "./PageMediaHeader.vue?vue&type=script&lang=ts&"
export * from "./PageMediaHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports